(function ($, document, window) {
	'use strict';

	$('.js-featured-carousel').each(function () {
		const sliderContainer = $(this);
		const sliderEl = $('.swiper', sliderContainer)[0];
		const disabledClass = 'featured-posts__collection--carousel-disabled';
		const navControlsClass = 'carousel-nav--no-controls';

		let swiper;
		const breakpoint = window.matchMedia('(min-width:80em)'); // keep track of swiper instances to destroy later

		const breakpointChecker = () => {
			if (swiper.destroyed) enableSwiper();

			$(sliderContainer).removeClass(disabledClass);
			$('.js-carousel-nav', sliderContainer).removeClass(navControlsClass);

			if (breakpoint.matches) {
				const numSlides = swiper.wrapperEl.querySelectorAll('.js-featured-carousel-slide:not(.swiper-slide-duplicate)').length;

				if ((numSlides <= 3)) {
					swiper.destroy(true, true);
					$(sliderContainer).addClass(disabledClass);
					$('.js-carousel-nav', sliderContainer).addClass(navControlsClass);
				}

				return;
			} else {
				const numSlides = swiper.wrapperEl.querySelectorAll('.js-featured-carousel-slide:not(.swiper-slide-duplicate)').length;

				if (numSlides <= 1) {
					swiper.destroy(true, true);
					$(sliderContainer).addClass(disabledClass);
					$('.js-carousel-nav', sliderContainer).addClass(navControlsClass);
				}
			}
		};

		const enableSwiper = () => {
			swiper = new Swiper(sliderEl, {
				direction: 'horizontal',
				slidesPerView: 'auto',
				loop: false,
				spaceBetween: 20,
				slidesPerView: 1.6,
				breakpoints: {
					768: {
						slidesPerView: 2.3,
					},
					1280: {
						slidesPerView: 'auto',
					}
				}
			});

			$('.js-carousel-nav-next', sliderContainer).each(function () {
				$(this).on('click', function () {
					swiper.slideNext();
				});
			});

			$('.js-carousel-nav-prev', sliderContainer).each(function () {
				$(this).on('click', function () {
					swiper.slidePrev();
				});
			});
		};

		$(function () {
			enableSwiper();
			breakpoint.addListener(breakpointChecker); // kickstart
			breakpointChecker();
		});
	});
})(jQuery, document, window);
